import Accordion from 'react-bootstrap/Accordion';
import { tss } from 'tss-react';

import { AccordionBody } from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/Detail/AccordionBody';
import { AccordionHeader } from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/Detail/AccordionHeader';
import { RecipeErpViewComponentProps } from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/Index';
import * as Calculation from 'types/Recipe/Calculation';
import * as ErpRecipe from 'types/Recipe/Detail/ErpNew/ErpRecipe';

type IProps = RecipeErpViewComponentProps;

export const IngredientListAccordion = (
	props: IProps & {
		isLoaded: boolean;
		erpRecipe: ErpRecipe.Type;
		calculation: Calculation.Type;
	}
) => {
	const { classes } = useStyles();
	if (!props.erpRecipe) return <></>;
	return (
		<Accordion defaultActiveKey="0">
			{props.erpRecipe.ingredients.map((e, i) => {
				return (
					<Accordion.Item eventKey={String(i)} key={i + 'item'}>
						<Accordion.Header>
							<AccordionHeader
								mapping={e}
								{...props}
								isLoaded={props.isLoaded}
								key={i}
							/>
						</Accordion.Header>

						<Accordion.Body className={classes.body}>
							<AccordionBody
								mapping={e}
								{...props}
								isLoaded={props.isLoaded}
								key={i}
							/>
						</Accordion.Body>
					</Accordion.Item>
				);
			})}
		</Accordion>
	);
};

const useStyles = tss.create({
	body: {
		border: '5px solid #e0ebf5',
		borderTop: '0',
	},
});
